import type { PageNameType } from './clientConfiguration/clientConfigurationSlice';
import { getBaseDomain } from './pageDomain';

export const apiVersion = {
	results: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		approveResult: 2,
		getResultPictures: 2,
		getTableExcel: 2,
	},
	customers: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	orders: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	vehicles: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	products: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	'products/groups': {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	contracts: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	'contracts/details': {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	spy: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
		getSpyPhotos: 1,
	},
	weightings: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	drivers: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	destPoint: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		// these are not used in destPoint
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	'destPoint/details': {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	taskScheduler: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		// these are not used in taskScheduler (no backend endpoints)
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	requestedMsg: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		// these are not used in requestedMsg (no backend endpoints)
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	cards: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		// these are not used in cards
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	'cards/cardtimes': {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
		getCardtimePictures: 1,
	},
	settings: {
		getTable: 2,
		getItem: 2,
		createItem: 2,
		updateItem: 2,
		deleteItems: 2,
		deleteItem: 2,
		getTableStructure: 2,
		getItemDocuments: 2,
		uploadItemDocuments: 2,
		deleteItemDocument: 2,
		getTableExcel: 2,
	},
	identity: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
		generateKeyApi: 1,
		identityUserUpdate: 1,
		identityGetAccessGroups: 1,
		identityForgotPassword: 1,
		identityResetPassword: 1,
	},
	licenses: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	accessGroups: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	audit: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	users: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
		usersGetDatabases: 1,
		usersAttachDatabase: 1,
		usersDetachDatabase: 1,
	},
	IoT: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	warehouse: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	inventorization: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
	dynamicTables: {
		getTable: 1,
		getItem: 1,
		createItem: 1,
		updateItem: 1,
		deleteItems: 1,
		deleteItem: 1,
		getTableStructure: 1,
		getItemDocuments: 1,
		uploadItemDocuments: 1,
		deleteItemDocument: 1,
		getTableExcel: 1,
	},
};

// Contracts and RequestedMsg endpoints expose no PATCH — every update must
// PUT the full DTO to /update/{id}.
const putOnlyTables: string[] = [
	'contracts',
	'contracts/details',
	'requestedMsg',
];

export const isPutOnlyTable = (table: string) => putOnlyTables.includes(table);

export const getApiVersion = (
	table: PageNameType,
	// keyof over the config union = actions common to every table (unchanged
	// semantics; `typeof table` can no longer index since PageNameType gained a
	// template-literal member).
	action: keyof (typeof apiVersion)[keyof typeof apiVersion],
) => {
	// Runtime table names (`dynamicTables/{TableName}`) resolve via base domain.
	const tableConfig =
		apiVersion[table as keyof typeof apiVersion] ??
		apiVersion[getBaseDomain(table) as keyof typeof apiVersion];
	if (!tableConfig) {
		console.error(`getApiVersion: unknown table "${String(table)}"`);
		return 1;
	}

	const version = (tableConfig as Record<string, number>)[action as string];
	if (typeof version !== 'number') {
		console.error(
			`getApiVersion: unknown action "${String(action)}" for table "${String(table)}"`,
		);
		return 1;
	}
	return version;
};
